<div class="category-box-wrapper" [ngStyle]="{'background': 'url(' + category.image_url + ') no-repeat '}">
  <div class="category-content">
    <p>{{category.mobile_display_name}}
    </p>
  </div>
</div>